export const TYPE = {
  BASIC: 'Basic',
  OFFICIAL: 'Official'
};



// WEBPACK FOOTER //
// src/constants/layoutManagement.js